module.exports = __webpack_public_path__ + "img/goodsC1.416064b3.png";